import { Common } from '@sv-support-sdk/shared-types';

const getAnchor = ({ name, url, id }: Common.Tickets.IAttachment) =>
  `<a id="${id}" class="attach-anchors link link--blue" file-link href="${url}">${name}</a>`;

export const createLinksWithAttachments = (message: string, attachments: Common.Tickets.IAttachment[]) => {
  return message.replace(/{@(.*?)}/g, (item) => {
    const attach = attachments.find((attachment) => item.includes(String(attachment.id)));

    return attach ? getAnchor(attach) : '';
  });
};
